export default class Aliquotas {

    constructor(produtos= 1,frango=false,codigoProduto= 0,inadimplente = true, simplesNacional = false, origem = '', destino = '', valorOperacao = 0, frete = 0, despesasAcessorias = 0, AliquotaInterna = 0, ReInterna = 0, ReInterestadual = 0, importada = false, icms = false, mva=0,destinatario=0,finalidade=0,ipi=0,margem=0,precoMedio=0) {
       this.produtos = produtos
        this.frango = frango
        this.codigoProduto =codigoProduto
        this.inadimplente =inadimplente
        this.simplesNacional = simplesNacional
        this.origem = origem;
        this.destino = destino;
        this.valorOperacao = valorOperacao;
        this.frete = frete;
        this.despesasAcessorias = despesasAcessorias;
        this.AliquotaInterna = AliquotaInterna;
        this.ReInterna = ReInterna;
        this.ReInterestadual = ReInterestadual;
        this.importada = importada;
        this.icms = icms;
        this.mva = mva;
        this.destinatario = destinatario;
        this.finalidade = finalidade;
        this.ipi = ipi;
        this.margem = margem;
        this.precoMedio = precoMedio;
    }
    stringtoFloat() {
        return [
            this.origem,
            this.destino,
            parseFloat(this.valorOperacao),
            parseFloat(this.frete),
            parseFloat(this.despesasAcessorias),
            parseFloat(this.AliquotaInterna),
            parseFloat(this.ReInterna),
            parseFloat(this.ReInterestadual),
            this.importada,
            this.icms,
            parseFloat(this.mva)
        ]
    }

    valida() {
        //se todos campos forem válidos retorna 1
        if (this.origem)
            if (this.destino)
                if (parseFloat(this.valorOperacao) > 0)
                    if (parseFloat(this.frete) >= 0)
                        if (parseFloat(this.despesasAcessorias) >= 0)
                            if (parseFloat(this.AliquotaInterna) >= 0)
                                if (parseFloat(this.ReInterna) >= 0)
                                    if (parseFloat(this.ReInterestadual) >= 0)
                                        return 1;

        //se houver um campo inválido retorna 0
        return 0;
    }
}


// WEBPACK FOOTER //
// ./src/models/Aliquotas.js